import { FormGroupName } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';

import { HttpClient, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';

import { FormGroup } from '@angular/forms';

import { FormPackage } from '../../models/df-package';
import { ComponentService } from '../../../../../../../services/component.service';

@Component({
	selector: 'df-multi-select',
	templateUrl: './multi-select.component.html',
	styleUrls: ['./multi-select.component.scss']
})
export class MultiSelectComponent implements OnInit {
	@Input() package: FormPackage;
	@Input() form: FormGroup;
	@Input() config: FormGroup;
	@Input() componentData: any;
	public options = [];
	public selections = {};

	selectedItems: Array<any> = [];
	externalData: any = [];
	externalItems = [];
	msItems: Array<any> = [];
	msSettings: any = {};
	configUrl;

	constructor(private http: HttpClient, private cs: ComponentService) {}

	ngOnInit(): void {
		this.options = this.package.options;

		this.selectedItems = this.cs.componentData['value']['config'][this.package.key];

		this.getMultSelectData();

		this.msSettings = {
			singleSelection: this.package.settings.singleSelection,
			text: this.package.settings.placeholder,
			selectAllText: 'Select All',
			unSelectAllText: 'UnSelect All',
			enableSearchFilter: true,
			classes: 'creator-multi-select',
			primaryKey: this.package.settings.primaryKey,
			labelKey: this.package.settings.labelKey
		};
	}

	getMultSelectData() {
		if (this.package['externalOptions']) {
			this.configUrl = this.package['externalOptions'];
			this.http.get(this.configUrl).subscribe((data) => {
				this.externalData = data;
				this.msItems = [...this.msItems, ...this.externalData];
			});
		} else if (this.package.options) {
			this.msItems = [...this.msItems, ...this.package.options];
		} else if (this.package.defaultValue) {
			this.msItems = [...this.msItems, ...this.package.defaultValue];
		} else {
			this.msItems = [{ id: 1, itemName: 'No Options Available - Update Config' }];
		}
	}
}
